import styled from "styled-components";

export const Styles = styled.div`
  .field-section {
    width: max-content;
    display: flex;
    flex-direction: column;
    gap: 10px;
    > label {
      font-size: 1rem;
      span {
        margin-left: 4px;
        color: #e74c3c;
        font-size: 20px;
      }
    }
    .ant-radio-group {
      padding: 4px 10px;
      border: 1px solid transparent;
      &.is-error {
        border-color: #e74c3c;
      }
    }
  }
`;
